import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['element']

  changeTarget(event) {
    for (const item of this.elementTargets) {
      if (item.matches(event.params.target) && (!event.params.condition || window[event.params.condition](event.target))) {
        for (const input of item.querySelectorAll('input')) {
          input.disabled = false
        }
        $(item).collapse('show')
      } else {
        $(item).collapse('hide')
      }
    }
  }

  elementTargetConnected(target) {
    $(target).on('hidden.bs.collapse', () => {
      for (const input of target.querySelectorAll('input')) {
        input.disabled = true
      }
    })
  }
}
